module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1081137"
    }
  }, [_c('b', [_vm._v("EASY AÏOLI")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1081637"
    }
  }, [_c('b', [_c('i', [_vm._v("Aïoli (ay-OH-lee), a garlic mayonnaise from Provence, is the classic condiment for Bouillabaisse. It’s wonderful as a dip for vegetables and as a sauce for fish or lamb.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1083237"
    }
  }, [_c('b', [_vm._v("Prep: 5 minutes plus cooling "), _c('br'), _vm._v(" Cook: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1084037"
    }
  }, [_vm._v("1⅛ teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1085137"
    }
  }, [_vm._v("1 head garlic, separated into cloves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1085437"
    }
  }, [_vm._v("½ cup mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1086437"
    }
  }, [_vm._v("2 teaspoons fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1086737"
    }
  }, [_vm._v("½ teaspoon Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1087637"
    }
  }, [_vm._v("⅛ teaspoon ground red pepper (cayenne)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1088637"
    }
  }, [_vm._v("¼ cup extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1089737"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 2-quart saucepan, combine "), _c('i', [_vm._v("4 cups water ")]), _vm._v("and 1 teaspoon salt; heat to boiling over high heat. Add garlic and boil until garlic has softened, about 20 minutes. Drain. When cool enough to handle, squeeze soft garlic from each clove into small bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1092137"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In blender, puree garlic, mayonnaise, lemon juice, mustard, remaining ⅛ teaspoon salt, and ground red pepper until smooth. With blender running, through hole in cover, add oil in slow, steady stream until mixture is thickened. Transfer to bowl; cover and refrigerate up to 4 hours. Makes about ¾ cup.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1096437"
    }
  }, [_vm._v("Each tablespoon: About 112 calories, 0g protein, 2g carbohydrate, 12g total fat (2g saturated), 5mg cholesterol, 276mg sodium.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e1097437"
    }
  }, [_c('b', [_vm._v("CREAM CHEESE TO THE RESCUE")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "l.jpg",
      "src": "Images/l.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e1098137"
    }
  }, [_vm._v("Unexpected guests? For an almost-instant spread, place an 8-ounce block of cream cheese on a serving platter and spread generously with hot pepper jelly, mango chutney, olive paste (olivada), or salsa. Or, in a food processor with the knife blade attached, puree cream cheese with marinated dried tomatoes, roasted peppers, pickled jalapeño chiles, prepared horseradish, or grated onion; season with coarsely ground pepper. (If you wish, thin the spread with milk to make a dip.) No crackers? Toast some bread and cut into triangles.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082db0a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c23_r1.vue
// module id = 135
// module chunks = 0